module.exports = __webpack_public_path__ + "img/01_body_1200mk2_VG+.6d68cc24.png";